import { preload } 		from './modules/mod_preload'
import { navigation } 	from './modules/mod_navigation'
import { slider } 		from './modules/mod_slider'
// import { counter } 		from './modules/mod_counter'
import { reveal } 		from './modules/mod_reveal'
import { compare } 		from './modules/mod_compare'
import { ctaParallax }	from './modules/mod_cta_parallax'
import { rellax } 		from './modules/mod_rellax'

window.onload = function () {
	preload()
	navigation()
	slider()
	// counter()
	reveal()
	compare()
	ctaParallax()
	rellax()
}
